import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap, map, startWith, catchError, filter } from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';

import {
  FavoriteAction,
  FavoriteActionTypes,
  loadingFavorites,
  loadedFavorites,
  loadingFavoritesFailed,
  createdFavorite,
  creatingFavoriteFailed, deletedFavorite, deletingFavorite, deletingFavoriteFailed,
} from '../actions/favoriteActions';
import { IState } from '../reducers';
import {
  getFavorites,
  createFavorite,
  deleteFavorite,
} from '../../services/favoriteApi';

const getFavoritesEpic: Epic<FavoriteAction, FavoriteAction, IState> = (
  action$,
  state$,
  { dispatch }
) =>
  action$.pipe(
    filter(isOfType(FavoriteActionTypes.LOAD_FAVORITES)),
    switchMap((action: any) =>
      from(getFavorites()).pipe(
        map((response: any) => {
          return loadedFavorites(response.result);
        }),
        startWith(loadingFavorites()),
        catchError(() => of(loadingFavoritesFailed()))
      )
    )
  );
const createFavoriteEpic: Epic<FavoriteAction, FavoriteAction, IState> = (
  action$,
  state$,
  { dispatch }
) =>
  action$.pipe(
    filter(isOfType(FavoriteActionTypes.CREATE_FAVORITE)),
    switchMap((action: any) =>
      from(createFavorite(action.payload)).pipe(
        map((response: any) => createdFavorite(response)),
        catchError(() => of(creatingFavoriteFailed()))
      )
    )
  );

const deleteFavoriteEpic: Epic<FavoriteAction, FavoriteAction, IState, any> = (
  action$: any,
  state$: any,
  {dispatch}: any
) =>
  action$.pipe(
    filter(isOfType(FavoriteActionTypes.DELETE_FAVORITE)),
    switchMap((action: any) =>
      from(deleteFavorite(action.payload)).pipe(
        map((response: any) => {
          return deletedFavorite(action.payload);
        }),
        startWith(deletingFavorite()),
        catchError((error: any) => {
          const message = error.response?.data?.message || "";

          return of(deletingFavoriteFailed());
        })
      )
    )
  );

export default combineEpics(
  getFavoritesEpic,
  createFavoriteEpic,
  deleteFavoriteEpic,
);
